import { memo } from "react";
import type { ComponentMeta } from "../BuilderUI.types";
import { classNames } from "../utils/twMergeWithCNAndPrefix";

export interface PreviewBlockHoverProps {
  blockMeta: ComponentMeta;
  isFirstBlock: boolean;
}

export const PreviewBlockHover = memo(
  ({ blockMeta, isFirstBlock }: PreviewBlockHoverProps) => (
    <>
      <div
        className={classNames(
          "wb-pointer-events-none wb-absolute wb-bg-[#506CF0] wb-py-1 wb-px-3 wb-rounded wb-left-0 wb-top-[-30px] wb-z-50 wb-text-white wb-font-semibold wb-text-[11px] wb-uppercase",
          { "wb-top-[.5rem]": isFirstBlock },
        )}
      >
        {blockMeta.name}
      </div>
      <div className="wb-absolute wb-size-full wb-box-border wb-border-2 wb-z-40 wb-border-[#506CF0] wb-pointer-events-none wb-rounded-none" />
    </>
  ),
);

PreviewBlockHover.displayName = "PreviewBlockHover";
